export default class SearchTipItem {
    /**
     * @type {string}
     * @memberof SearchTipItem
     * @name 实体类型
     */
    public affair: string;
    /**
     * @type {string}
     * @memberof SearchTipItem
     * @name 实体类型名称
     */
    public affairName: string;
    /**
     * @type {string}
     * @memberof SearchTipItem
     * @name 描述
     */
    public description: string;
    /**
     * @type {string}
     * @memberof SearchTipItem
     * @name 全名
     */
    public fullname: string;
    /**
     * @type {string}
     * @memberof SearchTipItem
     * @name 编号
     */
    public no: string;
    /**
     * @type {string}
     * @memberof SearchTipItem
     * @name 全名
     */
    public resourceId: string;
    constructor({
        affair = '',
        affairName = '',
        description = '',
        fullname = '',
        no = '',
        resourceId = ''
    } = {}) {
        this.affair = affair
        this.affairName = affairName
        this.description = description
        this.fullname = fullname
        this.no = no
        this.resourceId = resourceId
    }
}